// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { customerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";
import { TextFieldProps } from "@insite/mobius/TextField";

customerAddressFormFieldStyles.firstNameGridItem = {
    width: [12, 6, 6, 6, 6],
};

customerAddressFormFieldStyles.firstNameText = {
    placeholder: translate("Enter First Name"),
} as TextFieldProps;

customerAddressFormFieldStyles.lastNameGridItem = {
    width: [12, 6, 6, 6, 6],
};

customerAddressFormFieldStyles.lastNameText = {
    placeholder: translate("Enter Last Name"),
} as TextFieldProps;

customerAddressFormFieldStyles.companyNameGridItem = {
    width: [12, 6, 6, 6, 6],
};

customerAddressFormFieldStyles.companyNameText = {
    placeholder: translate("Enter Company Name"),
} as TextFieldProps;

customerAddressFormFieldStyles.attentionGridItem = {
    width: [12, 6, 6, 6, 6],
};

customerAddressFormFieldStyles.attentionText = {
    placeholder: translate("Enter Attention"),
} as TextFieldProps;

customerAddressFormFieldStyles.address1Text = {
    placeholder: translate("Enter Address Line 1"),
} as TextFieldProps;

customerAddressFormFieldStyles.address2Text = {
    placeholder: translate("Enter Address Line 2 (Optional)"),
} as TextFieldProps;

customerAddressFormFieldStyles.address3Text = {
    placeholder: translate("Enter Address Line 3 (Optional)"),
} as TextFieldProps;

customerAddressFormFieldStyles.address4Text = {
    placeholder: translate("Enter Address Line 4 (Optional)"),
} as TextFieldProps;

customerAddressFormFieldStyles.cityText = {
    placeholder: translate("Enter City Name"),
} as TextFieldProps;

customerAddressFormFieldStyles.postalCodeText = {
    placeholder: translate("Enter Zip Code"),
} as TextFieldProps;

customerAddressFormFieldStyles.phoneText = {
    placeholder: translate("(___) ___ - ____"),
} as TextFieldProps;

customerAddressFormFieldStyles.faxText = {
    placeholder: translate("(___) ___ - ____"),
} as TextFieldProps;
